import { render, staticRenderFns } from "./PoNumberList.vue?vue&type=template&id=5a72fd6c&"
import script from "./PoNumberList.vue?vue&type=script&lang=js&"
export * from "./PoNumberList.vue?vue&type=script&lang=js&"
import style0 from "./PoNumberList.vue?vue&type=style&index=0&id=5a72fd6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports